// extracted by mini-css-extract-plugin
export var active = "_24-b";
export var activeIndicator = "_24-6";
export var animate = "_24-a";
export var disabled = "_24-c";
export var flat = "_24-1";
export var fullWidth = "_24-3";
export var lg = "_24-9";
export var md = "_24-8";
export var redoButtonTabGroup = "_24-0";
export var sm = "_24-7";
export var tabButton = "_24-4";
export var tabButtonsContainer = "_24-2";
export var xs = "_24-5";